import { Directive, Input } from '@angular/core';

import { OfficeRoute } from '../../../shared/constants/office-route.enum';
import { PreloadService } from '../../services/preload.service';
import { HoverActionDirective } from './hover-action.directive';

@Directive({
    selector: 'a[ohpPreload]'
})
export class PreloadDirective extends HoverActionDirective {

    @Input('ohpPreload') public preloadPath: string | OfficeRoute;

    constructor(
        private readonly preloadService: PreloadService
    ) {
        super(() => this.preloadService.preload(this.preloadPath));
    }

    protected enabled() {
        return !!this.preloadPath;
    }
}
